// @flow
import * as React from 'react'
import {translate} from 'react-i18next'
import styled from 'styled-components'
import {
  Banner,
  Grid,
  Link,
  Loading,
  Organization,
  Section,
  SectionTitle,
  styles
} from 'tutellus-ui'
import {Query} from 'react-apollo'
import gql from 'graphql-tag'

import {Page} from './Page'

const ChannelListSection = styled(Section)`
    display: grid;
    grid-template-rows: 1fr auto;

    & ${SectionTitle} {
        text-align: left;
        &:after {
            display: none;
        }
    }
    & ${Grid} {
        margin-top: 1em;
    }
`
ChannelListSection.displayName = 'ChannelListSection'

const ChannelListOverview = styled.span`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1em;
    @media ${styles.media.tablet} {
      grid-template-columns: 1fr auto;
    }
    justify-content: space-between;
    align-items: center;
    text-align: left;
    & p {
        margin: 0;
    }
`
ChannelListOverview.displayName = 'ChannelListOverview'

const OrganizationCTA = styled(Organization)`
    & > div:last-child {
        display: none;
    }
    background: ${styles.colors.primary_btn};
`
OrganizationCTA.displayName = 'OrganizationCTA'

const SchoolCTA = styled(OrganizationCTA)`
    background: ${styles.colors.secondary_btn};
`
SchoolCTA.displayName = 'SchoolCTA'

const trim = string => {
  const trimmed = string.split(' ').slice(0, 20).join(' ')
  if (trimmed.length < string.length) {
    return trimmed.concat('…')
  }
  return trimmed
}

const Universities = translate('channels')(({t}) =>
  <ChannelListSection title={t('schools_title')}>
    <ChannelListOverview>
      <p>{ t('schools_description') }</p>
      <Link zen button
        href={t('urls:channels_universities')}
      >
        { t('schools_view_all') }
      </Link>
    </ChannelListOverview>
    <Query query={gql`{
      channels(type: UNIVERSITY, limit: 7) {
        code
        name
        headline
        image
        stats {
          course_count
          teacher_count
        }
      }
    }`}>
      {
        ({_error, loading, data}/*: {loading: bool, data: any} */) =>
          <Loading while={loading}>
            {
              data && data.channels
                ? <Grid sizes={{tablet: 3}}>
                  {
                    data.channels.map(({code, headline, stats, ...school}) =>
                      <Organization key={code}
                        {...school}
                        courses_title={t('courses_title')}
                        teachers_title={t('teachers_title')}
                        courses={stats.course_count}
                        teachers={stats.teacher_count}>
                        { trim(headline) }
                      </Organization>
                    )
                  }
                  <SchoolCTA name={t('schools_create_title')}
                    image={t('schools_create_icon')}>
                    <p>{ t('schools_create_description') }</p>
                    <Link zen button
                      href={t('urls:channels_universities_create')}
                    >
                      { t('schools_create_cta') }
                    </Link>
                  </SchoolCTA>
                </Grid>
                : null
            }
          </Loading>
      }
    </Query>
  </ChannelListSection>
)

const Schools = translate('channels')(({t}) =>
  <ChannelListSection title={t('organizations_title')}>
    <ChannelListOverview>
      <p>{ t('organizations_description') }</p>
      <Link zen button
        href={t('urls:channels_organizations')}
      >
        { t('organizations_view_all') }
      </Link>
    </ChannelListOverview>
    <Query query={gql`{
      channels(type: SCHOOL, limit: 7) {
        code
        name
        headline
        image
        stats {
          course_count
          teacher_count
        }
      }
    }`}>
      {
        ({_error, loading, data}/*: {loading: bool, data: any} */) =>
          <Loading while={loading}>
            {
              data && data.channels
                ? <Grid sizes={{tablet: 3}}>
                  {
                    data.channels.map(({code, stats, headline, ...organization}) =>
                      <Organization key={code}
                        {...organization}
                        courses_title={t('courses_title')}
                        teachers_title={t('teachers_title')}
                        courses={stats.course_count}
                        teachers={stats.teacher_count}>
                        { trim(headline) }
                      </Organization>
                    )
                  }
                  <OrganizationCTA name={t('organizations_create_title')}
                    image={t('organizations_create_icon')}>
                    <p>{ t('organizations_create_description') }</p>
                    <Link button zen
                      href={t('urls:channels_organizations_create')}
                    >
                      { t('organizations_create_cta') }
                    </Link>
                  </OrganizationCTA>
                </Grid>
                : null
            }
          </Loading>
      }
    </Query>
  </ChannelListSection>
)

export const Channels = translate('channels')(({t}) =>
  <Page>
    <Banner title={t('title')}
      background_url={t('background_url')}>
      <small>
        <p>{ t('description') }</p>
        <p>{ t('make_your_own') }</p>
      </small>
    </Banner>
    <Universities />
    <Schools />
  </Page>
)
Channels.displayName = 'Channels'



// WEBPACK FOOTER //
// ./src/pages/Channels.js